import {AfterViewInit, Component, OnDestroy, OnInit, Input, Output, EventEmitter} from "@angular/core";
import { EventManagerService } from '../../service/event-manager.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Constant } from '../../constant';
import { ShortcutService } from "../../service/shortcut.service";
import { ModalBase } from "../modal.base.component";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: 'confirm-popup',
  templateUrl: "./confirm-popup.html",
  styleUrls: ["./confirm-popup.scss"]
})

export class ConfirmPopupComponent extends ModalBase implements OnInit, OnDestroy {
    @Input('title') title;
    @Input('buttonLabel') buttonLabel = 'Xác nhận';
    @Input('buttonCancelLabel') buttonCancelLabel = 'Đóng';
    @Input() isDismissAll: boolean;
    @Output() result: EventEmitter<any> = new EventEmitter();
    iconImage: any = './assets/images/icons/warning.png';
    constructor(
        public eventManager: EventManagerService,
        public activeModal: NgbActiveModal,
        public ngModal: NgbModal
    ) {
        super(eventManager, activeModal)
    }
    argree() {
        this.dismiss();
        if (this.func) {
            this.func();
        } else this.result.emit(true);
    }
    cancel() {
        this.dismiss();
        if (this.cancelFunc) {
            this.cancelFunc();
        } else this.result.emit(false) 
    }
    dismiss() {
        ShortcutService.removeFuncEsc();
        if (!this.isDismissAll) {
            this.activeModal.dismiss();
        } else {
            this.ngModal.dismissAll();
        }
        this.result.emit(true);
    }
}
